export default {
    "other": "Khác",
    "air": "Đường hàng không",
    "sea": "Đường biển",
    "road": "Đường bộ",
}
